export class Expense {

  expense_id: number
  amount: number
  person: string
  category: string
  comment: string
  date: string
  paid: boolean

  constructor(e: any) {
    this.expense_id = e.expense_id || null
    this.amount = e.amount || null
    this.person = e.person || null
    this.category = e.category || null
    this.comment = e.comment || null
    this.date = e.date || null
    this.paid = e.paid || false
  }

  get _status(): string {
    return this.paid ? '已结' : '待结'
  }

  get _statusClass(): string {
    return this.paid ? 'btn-success' : 'btn-danger'
  }

  private statusClass(field: string = ''): string {
    return this.paid ? 'btn-success' : 'btn-danger'
  }

  public togglePaid() {
    this.paid = !this.paid
  }

}



// WEBPACK FOOTER //
// ./src/app/models/finance/expense.ts